import type { InfractionPaginatedRequest } from "../types/infraction-api.types";

export const infractionQueryKeys = {
	all: ["infractions"] as const,
	summary: () => [...infractionQueryKeys.all, "summary"] as const,
	paginated: (params: InfractionPaginatedRequest) =>
		[...infractionQueryKeys.all, "paginated", params] as const,
	detail: (infractionId: string | null) =>
		[...infractionQueryKeys.all, "detail", infractionId] as const,
	habilitarMeStatus: () =>
		[...infractionQueryKeys.all, "habilitarme-status"] as const,
	userProfile: () => [...infractionQueryKeys.all, "user-profile"] as const,
};
